export function getNotificationSubscriptionId(data: { topic: string; channel: string }) {
  return [data.topic, data.channel].join(':')
}
